import { Injectable } from "@angular/core";
import { ApolloError } from "@apollo/client";
import { Apollo } from 'apollo-angular';
import { DocumentNode } from 'graphql';
import { Observable, catchError, map, throwError } from "rxjs";
import { environment } from "../../../environments/environment";


@Injectable({ providedIn: 'root' })
export class BaseGraphqlService {

  constructor(private apollo: Apollo) { }


  /**
   *Metodo que se encarga de realizar consultas al backend
   *
   * @template T
   * @param {DocumentNode} query
   * @param {string} urlGraphql
   * @return {*}  {Observable<T>}
   * @memberof BaseGraphqlService
   */
  query<T>(query: DocumentNode, urlGraphql: string): Observable<T> {
    return this.apollo.watchQuery<{ data: T }>({
      query,
      context: { headers: this.getHeaders(), uri: urlGraphql },
      fetchPolicy: 'network-only',
    }).valueChanges.pipe(
      map((result) => result.data as T)

    );
  }



  /**
   *Metodo que se encarga de realizar consultas al backend por filtros
   *
   * @template T
   * @template F
   * @param {DocumentNode} query
   * @param {string} urlGraphql
   * @param {F} [filters]
   * @return {*}  {Observable<T>}
   * @memberof BaseGraphqlService
   */
  queryFilter<T, F>(query: DocumentNode, urlGraphql: string, filters?: any): Observable<T> {
    return this.apollo.watchQuery<{ data: T }>({
      query,
      variables: filters,
      context: { headers: this.getHeaders(), uri: urlGraphql },
      fetchPolicy: 'network-only',
    }).valueChanges.pipe(
      map((result) => result.data as T)
    );
  }




  mutation<T, F>(mutation: DocumentNode, urlGraphql: string, data: any) : Observable<T>{
    return this.apollo.mutate({
      mutation,
      variables: data,

      context: { headers: this.getHeaders(), uri: urlGraphql , useMultipart: false}
    }).pipe(
      map((result) => result.data as T)
    );
  }



  /**
   *Metodo que se encarga de organizar los headers de la peticion
   *
   * @private
   * @return {*}  {{ [key: string]: string }}
   * @memberof BaseGraphqlService
   */
  private getHeaders(): { [key: string]: string } {
    let stateApp: any;
    const headers = {
      'Authorization': '',
      'GraphQL-Preflight':'1',
      'X-Token': environment.x_token
    };
    return headers;
  }

}
